import { React, useCallback, useEffect, useState, useContext } from 'react';
import { Chip, Stack, Tooltip, Card, CardContent, Typography, Skeleton } from '@mui/material';
import { useStoreState } from 'pullstate';
import { AppStore } from '../stores/AppStore.js';

function Strengths(props) {
    const [employeeStrength, setEmployeeStrength] = useState([])
    const [colorsDescriptions, setColorsDescriptions] = useState({
        '#772882ff': 'Purple',
        '#ef7100ff': 'Orange',
        '#00935fff': 'Green',
        '#0073ceff': 'Blue',
    })
    const [colorsMeaning, setColorsMeaning] = useState({
        '#772882ff': 'Executing',
        '#ef7100ff': 'Influencing',
        '#00935fff': 'Strategic Thinking',
        '#0073ceff': 'Relationship Building',
    })
    const strengths = useStoreState(AppStore, s => s.strengths);
    const [skeleton, setSkeleton] = useState(true)

    useEffect(() => {
        const getUserStrengths = async () => {
            const userStrengths = strengths?.find(strength => strength.user_id === props.employeeId)
            if (userStrengths === undefined) {
                setEmployeeStrength(['No strengths found'])
                setSkeleton(false)
            } else {
                setEmployeeStrength([userStrengths])
                setSkeleton(false)
            }
        }
        getUserStrengths()

    }, [strengths, props.employeeId])

    return (
        <div>
            {skeleton ? (
                <Stack spacing={1}>
                    <Skeleton animation='wave' variant="text" width={552} height={24} />
                    <Skeleton animation='wave' variant="rectangular" width={552} height={64} />
                </Stack>
            ) : (
                employeeStrength[0] !== 'No strengths found' ? (
                    employeeStrength.map((strength, index) => (
                        <Card key={1} sx={{ alignItems: 'center', minWidth: 552 }}>
                            <Typography sx={{ 'textAlign': 'center' }} >CliftonStrengths®</Typography>
                            <CardContent>
                                <Stack justifyContent='space-between' direction="row" spacing={2}>
                                    <Tooltip
                                        title={
                                            <Stack>
                                                <Typography>{colorsDescriptions[strength.color_1]}: {colorsMeaning[strength.color_1]}</Typography>
                                                <Typography>Strength: {strength.description_1}</Typography>
                                            </Stack>
                                        }
                                        placement="top">
                                        <Chip sx={{ backgroundColor: strength.color_1, color: 'white' }} label={strength.strength_1} />
                                    </Tooltip>
                                    <Tooltip
                                        title={
                                            <Stack>
                                                <Typography>{colorsDescriptions[strength.color_2]}: {colorsMeaning[strength.color_2]}</Typography>
                                                <Typography>Strength: {strength.description_2}</Typography>
                                            </Stack>
                                        }
                                        placement="top">
                                        <Chip sx={{ backgroundColor: strength.color_2, color: 'white' }} label={strength.strength_2} />
                                    </Tooltip>
                                    <Tooltip
                                        title={
                                            <Stack>
                                                <Typography>{colorsDescriptions[strength.color_3]}: {colorsMeaning[strength.color_3]}</Typography>
                                                <Typography>Strength: {strength.description_3}</Typography>
                                            </Stack>
                                        }
                                        placement="top">
                                        <Chip sx={{ backgroundColor: strength.color_3, color: 'white' }} label={strength.strength_3} />
                                    </Tooltip>
                                    <Tooltip
                                        title={
                                            <Stack>
                                                <Typography>{colorsDescriptions[strength.color_4]}: {colorsMeaning[strength.color_4]}</Typography>
                                                <Typography>Strength: {strength.description_4}</Typography>
                                            </Stack>
                                        }
                                        placement="top">
                                        <Chip sx={{ backgroundColor: strength.color_4, color: 'white' }} label={strength.strength_4} />
                                    </Tooltip>
                                    <Tooltip
                                        title={
                                            <Stack>
                                                <Typography>{colorsDescriptions[strength.color_5]}: {colorsMeaning[strength.color_5]}</Typography>
                                                <Typography>Strength: {strength.description_5}</Typography>
                                            </Stack>
                                        }
                                        placement="top">
                                        <Chip sx={{ backgroundColor: strength.color_5, color: 'white' }} label={strength.strength_5} />
                                    </Tooltip>
                                </Stack>
                            </CardContent>
                        </Card>
                    ))
                ) : (
                    <Card key={1} sx={{ alignItems: 'center', minWidth: 552 }}>
                        <Typography sx={{ 'textAlign': 'center' }} >CliftonStrengths®</Typography>
                        <CardContent>
                            <Typography sx={{ 'textAlign': 'center' }} >No strengths found</Typography>
                        </CardContent>
                    </Card>
                )
            )
            }
        </div >
    );
}

export default Strengths